import type { TFunction } from "i18next";

export enum CredentialValidationError {
	InvalidCredentials,
	ExternalError,
}

export function credentialValidationErrorToMessage(
	error: CredentialValidationError,
	t: TFunction,
): string {
	switch (error) {
		case CredentialValidationError.InvalidCredentials:
			return t("settings.integrations.credential_invalid");
		case CredentialValidationError.ExternalError:
			return t("settings.integrations.credential_save_failed");
	}
}
